import { Action, INIT } from '@ngrx/store';

export const NGRX_INIT: Action = {
  type: INIT
};
